import { clsx } from 'clsx';
import { FC } from 'react';
import { P } from 'atoms/Typography';
import { Price } from 'molecules/Price';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './OldPrice.module.css';

export const OldPrice: FC<{
  amount?: number | null;
  currencyCode: string;
  isBundle?: boolean;
  className?: string;
  currencyClassName?: string;
  withoutLabel?: boolean;
}> = ({
  amount,
  currencyCode,
  isBundle = false,
  className,
  currencyClassName,
  withoutLabel = false,
}) => {
  const t = useTranslations();

  if (!amount) {
    return null;
  }

  return (
    <P className={clsx(styles.root, !isBundle && styles.crossed, className)}>
      {!withoutLabel
        ? isBundle
          ? t('product.tile.bundle-price')
          : t('product.tile.old-price')
        : null}
      <Price
        amount={amount}
        currencyCode={currencyCode}
        oldPrice
        className={className}
        currencyClassName={currencyClassName}
      />
    </P>
  );
};
